export const QUERY_KEYS = {
  ACCOUNT: ["ACCOUNT"],
  NOTES: ["NOTES"],
  FAVORITE: ["FAVORITE"],
  DELETED: ["DELETED"],
  NOTION_DATA: ["NOTION_DATA"],
};
